// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../primitives/I18n.res.js";
import * as Stdlib_Math from "@rescript/runtime/lib/es6/Stdlib_Math.js";

function startOfDay(date) {
  let date$1 = new Date(date.getTime());
  date$1.setHours(0, 0, 0, 0);
  return date$1;
}

function endOfDay(date) {
  let date$1 = new Date(date.getTime());
  date$1.setHours(23, 59, 59, 999);
  return date$1;
}

function isSameDay(dateA, dateB) {
  return startOfDay(new Date(dateA.getTime())).getTime() === startOfDay(new Date(dateB.getTime())).getTime();
}

function addDays(date, days) {
  let date$1 = new Date(date.getTime());
  date$1.setDate(date$1.getDate() + days | 0);
  return date$1;
}

function subDays(date, days) {
  return addDays(date, -days | 0);
}

function startOfWeek(date) {
  let day = date.getDay();
  let diff = ((
    day < 1 ? 7 : 0
  ) + day | 0) - 1 | 0;
  let date$1 = new Date(date.getTime());
  date$1.setDate(date$1.getDate() - diff | 0);
  return startOfDay(date$1);
}

function endOfWeek(date) {
  let day = date.getDay();
  let diff = ((
    day < 1 ? -7 : 0
  ) + 6 | 0) - (day - 1 | 0) | 0;
  let date$1 = new Date(date.getTime());
  date$1.setDate(date$1.getDate() + diff | 0);
  return endOfDay(date$1);
}

function addWeeks(date, weeks) {
  return addDays(date, weeks * 7 | 0);
}

function subWeeks(date, weeks) {
  return addWeeks(date, -weeks | 0);
}

function startOfMonth(date) {
  let date$1 = new Date(date.getTime());
  date$1.setDate(1);
  return startOfDay(date$1);
}

function lastDayOfMonthDate(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1 | 0, 0);
}

function getDaysInMonth(date) {
  return lastDayOfMonthDate(date).getDate();
}

function addMonths(date, months) {
  let year = date.getFullYear();
  let month = date.getMonth() + months | 0;
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();
  let date$1 = new Date(year, month, 1);
  let daysInMonth = lastDayOfMonthDate(date$1).getDate();
  let day = Math.min(daysInMonth, date.getDate());
  return new Date(year, month, day, hours, minutes, seconds);
}

function subMonths(date, months) {
  return addMonths(date, -months | 0);
}

function isSameMonth(dateA, dateB) {
  return startOfMonth(dateA).getTime() === startOfMonth(dateB).getTime();
}

function endOfMonth(date) {
  return endOfDay(lastDayOfMonthDate(date));
}

function startOfYear(date) {
  return new Date(date.getFullYear(), 0, 1, 0, 0, 0);
}

function addYears(date, years) {
  return addMonths(date, 12 * years | 0);
}

function subYears(date, years) {
  return addYears(date, -years | 0);
}

function endOfYear(date) {
  return endOfDay(new Date(date.getFullYear(), 11, 31));
}

function diffInDays(firstDate, lastDate) {
  let dayMs = 24 * 60 * 60 * 1000;
  let diff = lastDate.getTime() - firstDate.getTime();
  return Math.round(Math.abs(diff / dayMs)) | 0;
}

function diffInHours(firstDate, lastDate) {
  let hourMs = 60 * 60 * 1000;
  let diff = firstDate.getTime() - lastDate.getTime();
  return Stdlib_Math.Int.floor(Math.abs(diff / hourMs));
}

function getPreviousPeriod(startDate, endDate) {
  let days = diffInDays(startDate, endDate);
  let startDatePreviousPeriod = addDays(startDate, -days | 0);
  let days$1 = diffInDays(startDate, endDate);
  let endDatePreviousPeriod = addDays(endDate, -days$1 | 0);
  return [
    startDatePreviousPeriod,
    endDatePreviousPeriod
  ];
}

function getPreviousYearPeriod(startDate, endDate) {
  let startDatePreviousPeriod = addYears(startDate, -1);
  let endDatePreviousPeriod = addYears(endDate, -1);
  return [
    startDatePreviousPeriod,
    endDatePreviousPeriod
  ];
}

function formateToShortDate(date) {
  return I18n.dateTimeFormat(undefined, undefined, undefined, "2-digit", "2-digit", "2-digit", undefined, undefined, undefined, date);
}

function formateToNumericDate(date) {
  return I18n.dateTimeFormat(undefined, undefined, undefined, "numeric", "2-digit", "2-digit", undefined, undefined, undefined, date).replaceAll("/", " / ");
}

let formateToMediumDate = formateToNumericDate;

function formateToShortTime(localeOpt, date) {
  let locale = localeOpt !== undefined ? localeOpt : I18n.locale;
  let res = I18n.dateTimeFormat(locale, undefined, "short", undefined, undefined, undefined, "numeric", "numeric", undefined, date);
  if (locale === "fr-FR") {
    return res.replace(":", "h");
  } else {
    return res;
  }
}

export {
  startOfDay,
  endOfDay,
  isSameDay,
  addDays,
  subDays,
  startOfWeek,
  endOfWeek,
  addWeeks,
  subWeeks,
  startOfMonth,
  endOfMonth,
  isSameMonth,
  lastDayOfMonthDate,
  getDaysInMonth,
  addMonths,
  subMonths,
  startOfYear,
  endOfYear,
  addYears,
  subYears,
  diffInDays,
  diffInHours,
  getPreviousPeriod,
  getPreviousYearPeriod,
  formateToShortDate,
  formateToNumericDate,
  formateToMediumDate,
  formateToShortTime,
}
/* I18n Not a pure module */
